import React, { FC } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Form from 'components/form/Form';
import FormGroup from 'components/form/FormGroup';
import setServerErrors from 'utils/helpers/formErrors';
import API from 'core/Api';
import { createErrorFromResponse } from 'core/Error';
import { useModal } from 'store/modal';

interface IInputs {
  email: string;
}

const ForgottenPasswordForm: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const methods = useForm<IInputs>();
  const { showModal } = useModal();
  const onSubmit = (data: IInputs) => {
    return API.post('auth/send-password-reset-email', {
      email: data.email,
    })
      .then(res => {
        showModal({
          type: 'success',
          content: res.data.msg,
        });
        history.push('/');
      })
      .catch(err => setServerErrors(createErrorFromResponse(err).errors, methods.setError));
  };
  return (
    <div>
      <Form
        methods={methods}
        onSubmit={onSubmit}
        btnLabel={t('auth.forgottenPassword.send')}
        hideCancelBtn
      >
        <FormGroup
          controlId="formGroupEmail"
          label={t('auth.forgottenPassword.email')}
          type="email"
          placeholder={t('auth.forgottenPassword.emailPlaceholder')}
          name="email"
          isRequired
        />
      </Form>
      <div className="text-center mt-3">
        <Link
          to="#"
          onClick={() => history.goBack()}
        >
          {t('common.back')}
        </Link>
      </div>
    </div>
  );
};

export default ForgottenPasswordForm;
